<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid tax-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Tax Reporting Database</h4>
            <hr />
            <div class="col-sm-5 col-md-5 card summary" v-if="generatedReport">
              <div class="m-3" v-if="generatedReport.message === null">
                <h4>Report Generated</h4>
                <hr />
                <p>
                  Your database has been sent to {{ generatedReport.email }}.
                </p>
                <label
                  >{{ generatedReport.ordersCount.toLocaleString() }} Order
                  Records</label
                >
                <label
                  >{{ generatedReport.pointAdditionsCount.toLocaleString() }}
                  Points Added Records
                </label>
                <label
                  >{{ generatedReport.pointSubtractionsCount.toLocaleString() }}
                  Points Subtracted Records
                </label>
                <label>
                  {{ generatedReport.creditsCount.toLocaleString() }} Credit
                  Records
                </label>
                <hr />
                <label>
                  {{ generatedReport.orderPointsTotal.toLocaleString() }} points
                  in orders
                </label>
                <label>
                  {{ generatedReport.orderTaxesPointsTotal.toLocaleString() }}
                  points in order taxes
                </label>
                <label>
                  {{ generatedReport.pointAdditionsTotal.toLocaleString() }}
                  points added
                </label>
                <label>
                  {{ generatedReport.pointSubtractionsTotal.toLocaleString() }}
                  points subtracted
                </label>
                <label>
                  {{ generatedReport.creditPointsTotal.toLocaleString() }}
                  points credited
                </label>
                <hr />
              </div>
              <div class="m-3" v-if="generatedReport.message !== null">
                {{ generatedReport.message }}
              </div>
              <div class="fileUploadResultAction">
                <button
                  class="btn btn-secondary btn-lg btn-sm-block mr-1 my-2"
                  @click="closeFileSave()"
                >
                  Close
                </button>
              </div>
            </div>
            <tax-reporting-database-form />
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import TaxReportingDatabaseForm from "./TaxReportingDatabaseForm.vue";

export default {
  name: "TaxReportingDatabase",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    taxReportingDatabaseForm: TaxReportingDatabaseForm,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsTaxReportingDatabase",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },
    closeFileSave() {
      this.$store.dispatch("taxReport/resetGeneratedReport");
    },
  },
  created() {
    this.setActiveMenuItem();
    this.$store.dispatch("taxReport/fetchAuthorizedClients");
  },
  computed: {
    generatedReport() {
      return this.$store.getters["taxReport/getGeneratedReport"];
    },
  },
};
</script>

<style lang="scss" scoped>
.tax-report {
  // margin: 70px 0 0 0;
  min-height: 100%;
  margin: -0.5% 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
  .card {
    background-image: url(https://new.incentiveweb.com/img/bg-blue.75d34f7d.svg);
    max-width: 100%;
    border-radius: $border-radius-sm;
    background-position: top center;
    background-repeat: repeat;
    background-size: 90px;
    background-color: #f0f9ff;
    label {
      display: block;
    }
  }
  .fileUploadResultAction {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

html,
body {
  height: 100%;
}
</style>
